<template>
  <div class = "proprietorNotificationList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addNotif')}}</el-button>
      <el-table
        :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="sendType"
          :label="$t('lang.lab_sendType')"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.sendType === 1">{{$t('lang.lab_proprietor')}}</span>
            <span v-if="scope.row.sendType === 2">{{$t('lang.lab_property')}}</span>
            <span v-if="scope.row.sendType === 3">{{$t('lang.lab_proprietorAndProperty')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="通知类型" prop="noticeType">
          <template slot-scope="scope">
            <span :class="{'important-notice': scope.row.noticeType === 1}">{{ scope.row.noticeType === 0 ? '普通通知' : '重大事项通知' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          :label="$t('lang.lab_titleNotif')">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('lang.lab_createTime')"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:proprietorNotificationList
 *@Description:业主通知
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-02-19
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      multipleSelection: [], // 多选框
      tableData: [], // 通知list
      type: 2, // 1:楼 2：单元 3：房间
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('yztzform', '')
      window.localStorage.setItem('yztzsaveData', '')
    }, 200)
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.getData()
    }
  },
  methods: {
    // 业主通知-获取列表数据
    getData() {
      let loading = this.$loading()
      this.$get(`/notices?gardenId=${this.gardenId}&type=${this.type}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        }, 
        error => {
          loading.close()
          this.$message.error(error)
        })
    },
    // 新增通知
    add() {
      window.localStorage.setItem('yztzform', '')
      window.localStorage.setItem('yztzsaveData', '')
      this.$router.push({ name: 'proprietorNotificationAdd', query: { flag: false } })
    },
    // 编辑通知
    edit(rowData) {
      window.localStorage.setItem('yztzform', '')
      window.localStorage.setItem('yztzsaveData', '')
      this.$router.push({ name: 'proprietorNotificationEdit',
      query: {
        flag: true,
        object: rowData }
        })
    },
    // 删除通知
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/notices/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
  .proprietorNotificationList {
    .important-notice {
      color: #f56c6c;
    }
  }
</style>